(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('SurfingReportCtrl', SurfingReportCtrl)
    ;

    /* @ngInject */
    function SurfingReportCtrl(DataFactory, $rootScope) {

        var vm = this;

        vm.surfingReportHeader = [];
        vm.source = {};

        DataFactory.getTableData('surfing-report').then(function (allData) {

            var surfingReport = {},
                source = {};

            angular.forEach(allData.rows, function (row) {
                var month = row.values[0];

                if (surfingReport[month] === undefined) {
                    surfingReport[month] = {
                        columns: allData.columns.slice(1),
                        rows: []
                    };

                    if ($rootScope.retroMonths.indexOf(month) !== -1) {
                        source[month] = 'Digital Ratings (Monthly) ' + month + '. *YouTube duration reporting is sourced from the IAB Video Report (' + month + ')';
                    } else {
                        source[month] = 'Digital Content Ratings, Text, ' + month + ', People 2+, Monthly Total.*YouTube reporting is sourced from DCR Monthly Total Video';
                    }
                }

                var brandData = {
                    values: []
                };

                for (var i = 1; i < row.values.length; i++) {
                    brandData.values.push(row.values[i]);
                }

                surfingReport[month].rows.push(brandData);
            });

            vm.surfingReport = surfingReport;
            vm.source = source;
        });
    }

})();
